import React, { useEffect, useState } from "react";

const isImageMostlyBlack = img => {
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");

	canvas.width = img.width;
	canvas.height = img.height;

	ctx.drawImage(img, 0, 0);

	const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);

	let darkPixels = 0;
	const total = data.length / 4;

	for (let i = 0; i < data.length; i += 4) {
		const r = data[i];
		const g = data[i + 1];
		const b = data[i + 2];

		const brightness = (r + g + b) / 3;

		if (brightness < 15) darkPixels++;
	}

	return darkPixels / total > 0.9; // 90% noir => image invalide
};

const loadImage = url =>
	new Promise(resolve => {
		const img = new Image();
		img.crossOrigin = "anonymous";

		img.onload = () => resolve(img);
		img.onerror = () => resolve(null);
		img.src = url;
	});

export const YouTubeThumbnail = ({ videoId }) => {
	const sources = [
		`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`,
		`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
		`https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`,
		`https://i.ytimg.com/vi/${videoId}/default.jpg`
	];

	const [src, setSrc] = useState(null);

	useEffect(() => {
		let cancelled = false;

		const run = async () => {
			for (let url of sources) {
				const img = await loadImage(url);

				if (!img) continue;

				const isBad = isImageMostlyBlack(img);

				if (!isBad && !cancelled) {
					setSrc(url);
					return;
				}
			}

			if (!cancelled) {
				setSrc("/placeholder-thumbnail.jpg");
			}
		};

		run();

		return () => {
			cancelled = true;
		};
	}, [videoId]);

	if (!src) return <div style={{ background: "#eee", height: 180 }} />;

	return <img src={src} alt="thumbnail" className="img-fluid image" />;
};
